import * as schema from "@/shared/state/visualization/schema/v1/three-d";

import { CameraSnapshot } from "./BabylonManager";

/**
 * Compute the camera spec to dispatch when the user toggles between
 * orbit and third-person modes.
 *
 * orbit → thirdPerson: capture the live camera's alpha/beta/radius and
 *   the followed entity's data-space position (from
 *   `cameraSnapshot`'s `target`) as the new focusPoint. Camera framing
 *   is preserved across the flip, so there's no first-frame jump.
 *
 * thirdPerson → orbit: discard the third-person framing; orbit
 *   construction defaults take over on the rebuild. The fallback entity
 *   provides the orbit spec's required `target` field.
 */
export function computeToggledCameraSpec(args: {
  current: schema.Camera;
  snapshot: CameraSnapshot;
  fallbackEntity: { id: string; mesh: "mesh" | "path" };
}): schema.Camera {
  const { current, snapshot, fallbackEntity } = args;
  if (current.type === schema.CAMERA_TYPE.orbit) {
    return {
      type: schema.CAMERA_TYPE.thirdPerson,
      focusPoint: {
        x: snapshot.target.x,
        y: snapshot.target.y,
        z: snapshot.target.z,
      },
      alpha: snapshot.alpha,
      beta: snapshot.beta,
      radius: snapshot.radius,
    };
  }
  return {
    type: schema.CAMERA_TYPE.orbit,
    target: { ...fallbackEntity },
    zoom: {},
  };
}
